import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import ActivateAccount from './components/ActivateAccount';
import CustomerDashboard from './components/CustomerDashboard';
import CustomerProfile from './components/CustomerProfile';
import AdminDashboard from './components/AdminDashboard';
import WhatsAppFloat from './components/WhatsAppFloat';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import { toast } from './hooks/use-toast';

const PAGES_WITH_OWN_HEADER = ['/', '/login', '/admin', '/dashboard'];

function AppContent() {
  const location = useLocation();
  const hideNavbar = PAGES_WITH_OWN_HEADER.includes(location.pathname);

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/activate" element={<ActivateAccount />} />
        <Route path="/dashboard" element={<CustomerDashboard />} />
        <Route path="/profile" element={<CustomerProfile />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <WhatsAppFloat />
      <PWAInstallPrompt />
      <Toaster />
    </>
  );
}

function App() {
  useEffect(() => {
    serviceWorkerRegistration.register({
      onSuccess: () => {
        console.log('PWA: App is ready for offline use');
      },
      onUpdate: (registration) => {
        console.log('PWA: New version available');
        toast({
          title: "Guncelleme Mevcut",
          description: "Yeni bir surum mevcut. Sayfayi yenileyebilirsiniz.",
        });
      }
    });
  }, []);

  return (
    <div className="App dark">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
